import { Layout, LayoutProps } from 'react-admin';
import { GybAppBar } from '../views/components/gyb-appbar';
import NestedMenu from '../views/components/nested-menu';

export const GybLayout: React.FC<LayoutProps> = (props) => Layout({ ...props, appBar: GybAppBar, menu: NestedMenu });